import { Component } from "react";
import { Nav } from "react-bootstrap";

import { Creatable, Destructable, Static } from "./index";

export default class NavItem extends Component {
    handleCreate = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();

        const { onCreate, ...payload } = this.props;
        if (onCreate) onCreate(payload);
    };

    handleDestroy = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();

        const { onDestroy, ...payload } = this.props;
        if (onDestroy) onDestroy(payload);
    };

    handleClick = (e) => {
        // Keep default anchor behavior unless you specifically want to suppress it:
        // e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
    };

    renderContent = () => {
        const { creator, created, destroyer, onDestroy, caption } = this.props;

        if (creator && !created) {
            return <Creatable caption={caption} onClick={this.handleCreate} />;
        }

        if (onDestroy && destroyer && created) {
            return (
                <Destructable
                    caption={caption}
                    onClick={this.handleClick}
                    onIconClick={this.handleDestroy}
                />
            );
        }

        if (created) {
            return <Static caption={caption} onClick={this.handleClick} />;
        }

        return null;
    };

    render() {
        const { name, selected, hidden } = this.props;
        const isActive = selected === name;

        return (
            <Nav.Item className="text-center">
                <Nav.Link
                    href={`#${name}`}
                    className={`${isActive ? "active" : ""} app-tab-link`}
                    hidden={hidden}
                    onClick={this.handleClick}
                >
                    {this.renderContent()}
                </Nav.Link>
            </Nav.Item>
        );
    }
}
